import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from "@angular/core";
import { ObligacionesCerradasDTO } from "../../../../../_models/perfil-cliente/obligacionesCerradas";
import { NavService } from "../../../../../_services/_nav.service";
import { DialogService } from "primeng/dynamicdialog";
import moment from 'moment/moment';

@Component({
  selector: "app-perfil-crezcamos-creditos-cerrados",
  templateUrl: "./perfil-crezcamos-creditos-cerrados.component.html",
  styleUrls: ["./perfil-crezcamos-creditos-cerrados.component.scss"],
})
export class PerfilCrezcamosCreditosCerradosComponent implements OnInit {
  @Input() informacionPerfil: any;
  obligacionesCerradas: ObligacionesCerradasDTO[];
  columnas: any[] = [];
  columnasFirmantes: any[] = [];
  showFirmantes: boolean = false;
  firmantes: any[] = [];
  numeroCredito: string = "";

  constructor(
    private navService: NavService,
    private diaService: DialogService,
  ) {}

  ngOnInit() {
    console.log(this.informacionPerfil);
    this.obligacionesCerradas =
      this.informacionPerfil && this.informacionPerfil.obligacionesCerradas
        ? this.informacionPerfil.obligacionesCerradas
        : null;
    this.setColumnasTablas();
  }

  setColumnasTablas() {
    this.columnas = [
      {
        field: "participacion",
        header: this.navService.buscarMensaje("PERFILCREZCAMOS.LBL_PARTICIPACION"),
        sort: false,
      },
      {
        field: "numeroCredito",
        header: this.navService.buscarMensaje("PERFILCREZCAMOS.LBL_NUMEROCREDITO"),
        sort: false,
      },
      {
        field: "fechaDesembolso",
        header: this.navService.buscarMensaje("PERFILCREZCAMOS.LBL_FECHADESEMBOLSO"),
        sort: false,
      },
      {
        field: "fechaCierre",
        header: this.navService.buscarMensaje("PERFILCREZCAMOS.LBL_FECHACIERRE"),
        sort: false,
      },
      {
        field: "montoDesembolsado",
        header: this.navService.buscarMensaje("PERFILCREZCAMOS.LBL_MONTODESEMBOLSADO"),
        sort: false,
      },
      {
        field: "liquidez",
        header: this.navService.buscarMensaje("PERFILCREZCAMOS.LBL_LIQUIDEZ"),
        sort: false,
      },
      {
        field: "actividadEconomica",
        header: this.navService.buscarMensaje("PERFILCREZCAMOS.LBL_ACTIVIDADECONOMICA"),
        sort: false,
      },
      {
        field: "garantia",
        header: this.navService.buscarMensaje("PERFILCREZCAMOS.LBL_GARANTIA"),
        sort: false,
      },
      {
        field: "numeroFirmantes",
        header: this.navService.buscarMensaje("PERFILCREZCAMOS.LBL_FIRMANTES"),
        sort: false,
      },
    ];

    this.columnasFirmantes = [
      {
        field: "nombreCompleto",
        header: this.navService.buscarMensaje("PERFILCREZCAMOS.LBL_NOMBRE"),
        sort: false,
      },
      {
        field: "codigoTipoDocumento",
        header: this.navService.buscarMensaje("PERFILCREZCAMOS.LBL_TIPODOCUMENTO"),
        sort: false,
      },
      {
        field: "numeroDocumento",
        header: this.navService.buscarMensaje("PERFILCREZCAMOS.LBL_NUMERODOCUMENTO"),
        sort: false,
      },
      {
        field: "vinculacion",
        header: this.navService.buscarMensaje("PERFILCREZCAMOS.LBL_VINCULACION"),
        sort: false,
      },
      {
        field: "parentesco",
        header: this.navService.buscarMensaje("PERFILCREZCAMOS.LBL_PARENTESTO"),
        sort: false,
      }
    ]
  }

  visualizarFirmantes( row: any ) {
    console.log(row)
    this.numeroCredito = row.numeroCredito;
    this.firmantes = row.firmantes;
    this.showFirmantes = true;
  }

  cerrarFirmantes(){
    this.numeroCredito = "";
    this.firmantes = [];
    this.showFirmantes = false;
  }
}
